//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeProcesRealizaceKnihaDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-12-02                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.38.1
//AdtGeneratorConfig:[ T:(srvvprk) GID:(Web.Set.Des.Ts) V1:(ixs_prr,ixs_pla,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeProcesRealizaceKnihaDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeProcesRealizaceKnihaDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_prr */
            public ixs_prr: string;
            /** PK - ixs_pla */
            public ixs_pla: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeProcesRealizaceKnihaListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeProcesRealizaceKnihaDesigner>, ixs_prr: string,ixs_pla: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_prr, ixs_pla);
            v_form.addRow("jres:33000146").addField("gselectbox", Gordic.Prefabs.Select.admSrvspla(), {
                dropdown: false,
                name: "ixs_pla",
                model: "model.ixs_pla=value.ixs_pla",
                initialValue: ixs_pla ? { ixs_pla: ixs_pla } : null,
                //graphicInput: "oninput",
                disabled: ixs_pla ? true : false,
            })
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction, {
                hardDefaultFilter: {
                    ixs_prr: ixs_prr,
                    ixs_pla: ixs_pla
                }
            });

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeProcesRealizaceKnihaDesigner>, ixs_prr: string,ixs_pla: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeProcesRealizaceKnihaDesigner>, ev, ctx): any {
            var filterObj = {
                ixs_pla: SeznamBase.filterContains(ctx.filter, "ixs_pla")
            }
            that.view = new Gordic.Isl.View(that.isl.AdeProcesRealizaceKniha.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeProcesRealizaceKnihaDesignerInit
         * 
         * @param {GContentType<SeznamAdeProcesRealizaceKnihaDesigner>} that
         */
        static SeznamAdeProcesRealizaceKnihaDesignerInit(that: GContentType<SeznamAdeProcesRealizaceKnihaDesigner>, ixs_prr: string,ixs_pla: string ) {
            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_prr,ixs_pla);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, ixs_prr, ixs_pla);

        } // SeznamAdeProcesRealizaceKnihaDesignerInit

        static LoadData(that: GContentType<SeznamAdeProcesRealizaceKnihaDesigner>, ixs_prr: string, ixs_pla: string) {
            var filterObj: any = {}
            if (ixs_pla) {
                new Gordic.Data.Readers.AdmSrvspla().getData({ ixs_pla: ixs_pla }).done((o) => {
                    that.filter.findFields("ixs_pla").gfield("setInitial", o[0]);
                })
                filterObj.ixs_pla = ixs_pla;
            }
            that.view = new Gordic.Isl.View(that.isl.AdeProcesRealizaceKniha.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        }

    }
}
